import reduceReducers from 'reduce-reducers'
import { combineReducers } from 'redux'

import {
  INGREDIENT_INITIAL_STATE,
  INGREDIENT_KEYWORDS_INITIAL_STATE,
} from '../initial-states'

import ingredientCommonNegativeSynonymPhrasesReducer from './ingredient-common-negative-synonym-phrases-reducer'
import ingredientKeywordsTransferReducer from './ingredient-keywords-transfer-reducer'
import ingredientMainKeywordsReducer from './ingredient-main-keywords-reducer'
import ingredientReducer from './ingredient-reducer'
import ingredientSpecialCaseReducer from './ingredient-special-case-reducer'
import ingredientSpecialCasesReducer from './ingredient-special-cases-reducer'
import ingredientSupportingKeywordsReducer from './ingredient-supporting-keywords-reducer'
import ingredientsReducer from './ingredients-reducer'

export default combineReducers({
  ingredients: ingredientsReducer,
  ingredient: reduceReducers(
    {
      ...INGREDIENT_INITIAL_STATE,
      keywords: INGREDIENT_KEYWORDS_INITIAL_STATE,
    },
    ingredientReducer,
    ingredientMainKeywordsReducer,
    ingredientSupportingKeywordsReducer,
    ingredientKeywordsTransferReducer,
  ),
  ingredientCommonNegativeSynonymPhrases:
    ingredientCommonNegativeSynonymPhrasesReducer,
  ingredientSpecialCases: ingredientSpecialCasesReducer,
  ingredientSpecialCase: ingredientSpecialCaseReducer,
})
